// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderLocation":"c-m_fN","advertDetailHeaderLocation__value":"c-m_fO"};